import styles from './driver-account-list.module.sass';

export const DriverAccountListItem = ({ mobile, onModifyButtonClick, isDeleteAllowed }) => {
  return (
    <li className={styles['driver-account-list-item']}>
      <p className={styles['mobile']}>{mobile}</p>
      {isDeleteAllowed && (
        <p className={styles['remove-button']} onClick={onModifyButtonClick}>
          移除
        </p>
      )}
    </li>
  );
};
